import React from 'react';
import {
  params, shape, string, number, useDataModel, arrayOf
} from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { CardProject } from './CardProject';
import { ProjectsCompletedSkeleton } from './ProjectsCompletedSkeleton';

const ProjectsCompleted = ({ city, state }) => {
  const { data, loading, error } = useDataModel('projectsCompletedByCity', {
    variables: { city, state },
    skip: !city || !state
  });

  const projects = data?.projectsCompletedByCity?.projects || [];

  if (loading) return <ProjectsCompletedSkeleton />;
  if (!projects.length || !data || error) return null;

  const cityResponse = data?.projectsCompletedByCity?.city;
  const totalProjectsCompleted = data?.projectsCompletedByCity?.totalProjectsCompleted;

  if (!cityResponse || !totalProjectsCompleted) return null;

  const sectionTitle = `${totalProjectsCompleted} Projects Completed By The Home Depot in ${cityResponse}`;

  return (
    <section className="sui-flex sui-flex-col sui-gap-4" data-component="ProjectsCompleted">
      <Typography variant="h2">{sectionTitle}</Typography>

      <div className="sui-grid sui-grid-cols-1 md:sui-grid-cols-2 lg:sui-grid-cols-3 sui-gap-4">
        {projects.map((project, index) => (
          <CardProject
            key={index}
            project={project}
            city={cityResponse}
          />
        ))}
      </div>
    </section>
  );
};

ProjectsCompleted.displayName = 'ProjectsCompleted';

ProjectsCompleted.dataModel = {
  projectsCompletedByCity: params({ city: string().isRequired(), state: string().isRequired() }).shape({
    city: string(),
    state: string(),
    totalProjectsCompleted: number(),
    projects: arrayOf(shape({
      title: string(),
      imageURL: string(),
      url: string(),
      totalJobs: number(),
    }))
  })
};

export { ProjectsCompleted };
